export default "__VITE_ASSET__BCDqzHVW__"